import { useMutation } from '@apollo/client'
import { gql } from '~/__generated__'

const TRACK_VIDEO_EVENT = gql(`
  mutation trackVideoEvent(
    $eventType: VideoEventEnum!
    $videoId: ID!
    $attributionToken: String
  ) {
    trackVideoEvent(
      input: {
        eventType: $eventType
        videoId: $videoId
        attributionToken: $attributionToken
      }
    ) {
      clientMutationId
    }
  }
`)

export const useTrackVideoEvent = () => {
  const [trackVideoEvent] = useMutation(
    TRACK_VIDEO_EVENT,
    { ignoreResults: true },
  )
  return { trackVideoEvent }
}
